import styled from 'styled-components'

import { appZIndex } from '@/presentation/utils/zIndexMapper'

export const Backdrop = styled.div`
  position: absolute;
  inset: 0;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 8px;
  background-color: ${({ theme }) => theme.colors.secondaryD2};
  opacity: 0.6;
`

export const ModalContainer = styled.div`
  position: absolute;
  inset: 0;
  z-index: ${appZIndex.MODAL};
  border-top-right-radius: 20px;
  border-bottom-right-radius: 8px;

  /* The root of the nexDS ConfirmModal, rendered right after our Backdrop: a fixed full-size overlay
     of its own (rgba(0, 0, 0, 0.2)) with square corners. Its class is generated, so it is reached by
     position. */
  & > ${Backdrop} + div {
    border-top-right-radius: 20px;
    border-bottom-right-radius: 8px;
  }

  & span {
    white-space: pre-line;
    text-align: left;
  }
`

export const InputsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 16px 0;
`
